export const ENV_MODE = import.meta.env.SYSTEM_MODE as 'development' | 'production' | 'uat';
export const ENV_TYPE = import.meta.env.SYSTEM_ENV_TYPE as 'internal' | 'public';
export const AZURE_KEY = import.meta.env.SYSTEM_AZURE_KEY as string;
export const WORKING_REGIONS = ((import.meta.env.SYSTEM_COUNTRY_REGIONS as string) || '').split(',');
export const TIMEZONE_FALLBACK = ((import.meta.env.SYSTEM_TIMEZONE_FALLBACK as string) || '').trim() as string;
export const ADDRESS_SEARCH_COUNTRIES = WORKING_REGIONS;
export const AMPLITUDE_KEY = import.meta.env.SYSTEM_AMPLITUDE_KEY as string;
export const MUI_LICENSE_KEY = ((import.meta.env.SYSTEM_MUI_LICENSE_KEY as string) || '').trim();
export const CHATWOOT_APP_ID = ((import.meta.env.SYSTEM_CHATWOOT_APP_ID as string) || '').trim();

export const ACCOUNT_MANAGERS_CONTACTS = [
  {
    avatarLink: '',
    contactName: 'Olivia Evans',
    phone: '+1 253-988-4652',
    email: 'oliviae7@shiftnex.com',
  },
  {
    avatarLink: '',
    contactName: 'Staffing Dept',
    phone: '+1 (206) 672-0500',
    email: 'staffing@shiftnex.com',
  },
];
